const sizeData = [
  {
    new: 'xxs',
    old: 'xs',
  },
  {
    new: 'xs',
    old: 's',
  },
  {
    new: 's',
    old: 'm',
  },
  {
    new: 'm',
    old: 'l',
  },
  {
    new: 'l',
    old: 'xl',
  },
  {
    new: 'xl',
    old: 'xxl',
  },
  {
    new: 'xxl',
    old: 'xxxl',
  },
]

const dualSizeData = [
  {
    new: 'xxs/xs',
    old: 'xs/s',
  },
  {
    new: 's/m',
    old: 'm/l',
  },
  {
    new: 'l/xl',
    old: 'xl/xxl',
  },
]

const convertNewToOldSizeWithDualSizing = (newSize) => {
  const findData = dualSizeData.find((item) => item.new === newSize)
  return findData?.old.toUpperCase() || newSize.toUpperCase()
}

const isNumeric = (string) => /^-?\d+$/.test(string)

const convertNewSizeToOldSize = (newSize) => {
  const isNumber = isNumeric(newSize)
  const isDualSize = newSize.includes('/')

  if (isNumber) {
    return parseInt(newSize, 10) + 1
  }

  if (isDualSize) {
    return convertNewToOldSizeWithDualSizing(newSize)
  }

  const findData = sizeData.find((item) => item.new === newSize)
  return findData?.old.toUpperCase() || newSize.toUpperCase()
}

export default convertNewSizeToOldSize
